<template>
  <div class="stand-alone">
    <!-- 左图表 -->
    <chart-list
      :isContEdit="isContEdit"
      :chartListData="chartList1"
      :chartListData2="data2"
      :chartListData3="pressedState"
    ></chart-list>
    <!-- 模型 -->
    <home-model
      :isContEdit="isContEdit"
      :standAloneData="AloneData"
    ></home-model>
    <!-- 右图表 -->
     <chart-list
      :isContEdit="isContEdit"
      :chartListData="chartList2"
      :chartListData2="pointAbnormality"
      :chartListData3="alarmInformation"
    >
    </chart-list>
  </div>
</template>
<script>
import chartList from "./chartList/chartList.vue";
import homeModel from "./model/model.vue";
import request from "@/assets/utils/request";
import infoCode from "@/module/infoCode.vue"
export default {
  components: {
    chartList,
    homeModel,
    infoCode
  },
  props: ["isEdit", "standAloneData"],
  data() {
    return {
      isContEdit: false,
      //左边图表数据
      chartList1: [],
      //右边图表数据
      chartList2: [],
      //统计分析页面的头部标题栏标题
      AloneData: {},
      //定义一个接口得数组
      MCArray: [
        "chargingSystem",
        "mixer",
        "coater",
        "rollerPress",
        "slitter",
        "dieCutting",
        "stack",
        "readyWeld",
        "finalWeld",
        "sealingTest",
        "hotplate",
        "liquidInjector",
        "forming",
        "sealing",
        "pressure",
        "winder",
      ],
      //定义一个机器型号得接口
      MCId: [
        "MC001",
        "MC002",
        "MC003",
        "MC004",
        "MC005",
        "MC006",
        "MC007",
        "MC008",
        "MC009",
        "MC014",
        "MC010",
        "MC011",
        "MC012",
        "MC013",
        "MC017",
        "MC015",
      ],
      getDataInterval: null,
      putInThePowderWeight:[],//投入粉体重量
      totalWeightOfLiquid:[],//液体总重量
      autorotationSpeed:[],//自转速度
      whiteSpaceWidth:[],//留白宽度
      BlayerTemperature:[],//B层温度
      BlayerVacuumValue:[],//B层真空值
      weighAfterInjection:[],//注液后称重
      lowerSealingKnifeTemperature:[],//下封刀温度
      pressedState:[],//压合状态
      alarmInformation:[],//报警信息
      data2:[],
      pointAbnormality:[],
      data:"data2",
      index:null,
      flag:null,
    };
  },
  created() {
    this.getChartData();
  },
  mounted() {
    this.getDataInterval = setInterval(() => {
      this.getChartData();
      this.silpt();
    }, 1000);
  },
  methods: {
    async getChartData() {
      this.index = this.$store.state.modelIndex;
      //判断是否是卷绕机0是卷绕机
      if (this.$store.state.flag == 0 && this.index == 6) {
          this.index = 14;
      }
      let res = await this.machine(this.MCArray[this.index], this.MCId[this.index])
      this.AloneData = res.data;
      this.$store.commit("dataUpdate",res.data);
    },
    silpt() {
      if (this.$store.state.data.machineId == "MC001") {
        //进行左边的3个数据选取【粉体总重量 液体投入重量  流量计】
        const selectedList = ["powderWeight", "liquidInputWeight", "flowmeter"];
        const _selectedList = [];
        selectedList.map((filedKey) => {
          const data = this.AloneData.chartVoList.find((item) => {
            return item.filedKey == filedKey;
          });
          if (data) _selectedList.push(data);
        });
        this.chartList1 = _selectedList;
       //进行右边的3个数据选取【设备状态 负压风机速度  产能效率】
        const selectedList2 = [ "deviceStatus","negativePressureFanSpeed","capacityEfficiency",];
        const _selectedList2 = [];
        selectedList2.map((filedKey) => {
          const data = this.AloneData.chartVoList.find((item) => {
            return item.filedKey == filedKey;
          });
          if (data) _selectedList2.push(data);
        });
        this.chartList2 = _selectedList2;
        //进行数据选取【投入粉体重量】
        const selectedList3 = ["putInThePowderWeight"];
        const _selectedList3 = [];
        selectedList3.map((filedKey) => {
          const data = this.AloneData.chartVoList.find((item) => {
            return item.filedKey == filedKey;
          });
          if (data) _selectedList3.push(data);
        });
        this.putInThePowderWeight = _selectedList3;
        this.weighAfterInjection = _selectedList3;
        this.data2 = _selectedList3;
        this.pointAbnormality = _selectedList2;
        this.pressedState = _selectedList;
        this.alarmInformation = _selectedList3;
        this.$store.commit("putInThePowderWeightUpdate", this.putInThePowderWeight);
        //进行数据选取【液体总重量】
        const selectedList4 = ["totalWeightOfLiquid"];
        const _selectedList4 = [];
        selectedList4.map((filedKey) => {
          const data = this.AloneData.chartVoList.find((item) => {
            return item.filedKey == filedKey;
          });
          if (data) _selectedList4.push(data);
        });
        this.totalWeightOfLiquid = _selectedList4;
        this.data2 = _selectedList3;
        this.pointAbnormality = _selectedList4;
        this.$store.commit("totalWeightOfLiquidUpdate", this.totalWeightOfLiquid);
      } else if (this.$store.state.data.machineId == "MC002") {
        //进行左边的3个数据选取【公转速度 搅拌温度  真空值】
        const selectedList = ["revolutionSpeed","stirringTemperature","vacuumValue"];
        const _selectedList = [];
        selectedList.map((filedKey) => {
          const data = this.AloneData.chartVoList.find((item) => {
            return item.filedKey == filedKey;
          });
          if (data) _selectedList.push(data);
        });
        this.chartList1 = _selectedList;
        //行右边的3个数据选取【设备状态 搅拌频率  搅拌最大速度】
        const selectedList2 = ["deviceStatus","stirringFrequency","stirAtMaximumSpeed"];
        const _selectedList2 = [];
        selectedList2.map((filedKey) => {
          const data = this.AloneData.chartVoList.find((item) => {
            return item.filedKey == filedKey;
          });
          if (data) _selectedList2.push(data);
        });
        this.chartList2 = _selectedList2;
        //数据选取【自转速度】
        const selectedList3 = [ "autorotationSpeed"];
        const _selectedList3 = [];
        selectedList3.map((filedKey) => {
          const data = this.AloneData.chartVoList.find((item) => {
            return item.filedKey == filedKey;
          });
          if (data) _selectedList3.push(data);
        });
        this.autorotationSpeed = _selectedList3;
        this.$store.commit("putInThePowderWeightUpdate", this.autorotationSpeed);
        this.$store.commit("totalWeightOfLiquidUpdate", this.chartList2);
      } else if (this.$store.state.data.machineId == "MC003") {
        //进行右边的3个数据选取【自动运行速度 涂布长度  螺旋泵速度】
        const selectedList = ["AutoRunninSpeed", "coatingLength", "ccrewPumpSpeed"];
        const _selectedList = [];
        selectedList.map((filedKey) => {
          const data = this.AloneData.chartVoList.find((item) => {
            return item.filedKey == filedKey;
          });
          if (data) _selectedList.push(data);
        });
        this.chartList1 = _selectedList;
        //进行左边的3个数据选取【设备状态 烘箱温度  放卷张力】
        const selectedList2 = ["deviceStatus","ovenTemperature", "unwindingTension",];
        const _selectedList2 = [];
        selectedList2.map((filedKey) => {
          const data = this.AloneData.chartVoList.find((item) => {
            return item.filedKey == filedKey;
          });
          if (data) _selectedList2.push(data);
        });
        this.chartList2 = _selectedList2;
        //数据选取【留白宽度】
        const selectedList3 = ["whiteSpaceWidth"];
        const _selectedList3 = [];
        selectedList3.map((filedKey) => {
          const data = this.AloneData.chartVoList.find((item) => {
            return item.filedKey == filedKey;
          });
          if (data) _selectedList3.push(data);
        });
        this.whiteSpaceWidth = _selectedList3;
        this.$store.commit("putInThePowderWeightUpdate", this.whiteSpaceWidth);
        this.$store.commit("totalWeightOfLiquidUpdate", this.chartList2);

      } else if (this.$store.state.data.machineId == "MC004") {
         //进行数据选取
        const selectedList = ["leftRollerGap", "hydraulicPressure", "data1"];
        const _selectedList = [];
        selectedList.map((filedKey) => {
          const data = this.AloneData.chartVoList.find((item) => {
            return item.filedKey == filedKey;
          });
          if (data) _selectedList.push(data);
        });
        this.chartList1 = _selectedList;
        //进行数据选取
        const selectedList2 = [
          "deviceStatus",
          "operatingSpeed",
          "data2",
        ];
        const _selectedList2 = [];
        selectedList2.map((filedKey) => {
          const data = this.AloneData.chartVoList.find((item) => {
            return item.filedKey == filedKey;
          });
          if (data) _selectedList2.push(data);
        });
        this.chartList2 = _selectedList2;
         this.$store.commit("putInThePowderWeightUpdate", this.chartList1);
        this.$store.commit("totalWeightOfLiquidUpdate", this.chartList2);
      } else if (this.$store.state.data.machineId == "MC005") {
        //进行数据选取
        const selectedList = ["AutoRunninSpeed", "poleWidth", "data1"];
        const _selectedList = [];
        selectedList.map((filedKey) => {
          const data = this.AloneData.chartVoList.find((item) => {
            return item.filedKey == filedKey;
          });
          if (data) _selectedList.push(data);
        });
        this.chartList1 = _selectedList;
        //进行数据选取
        const selectedList2 = [
          "deviceStatus",
          "unwindingTension",
          "rewindingTension",
        ];
        const _selectedList2 = [];
        selectedList2.map((filedKey) => {
          const data = this.AloneData.chartVoList.find((item) => {
            return item.filedKey == filedKey;
          });
          if (data) _selectedList2.push(data);
        });
        this.chartList2 = _selectedList2;
         this.$store.commit("putInThePowderWeightUpdate", this.chartList1);
        this.$store.commit("totalWeightOfLiquidUpdate", this.chartList2);
      } else if (this.$store.state.data.machineId == "MC006") {
        //进行右边的3个数据选取【生产效率 冲压速度  牵引速度】
        const selectedList = ["Productivity", "stampingSpeed", "tractionSpeed"];
        const _selectedList = [];
        selectedList.map((filedKey) => {
          const data = this.AloneData.chartVoList.find((item) => {
            return item.filedKey == filedKey;
          });
          if (data) _selectedList.push(data);
        });
        this.chartList1 = _selectedList;
         this.$store.commit("putInThePowderWeightUpdate", this.chartList1);
       //进行左边的3个数据选取【设备状态 放卷张力 收卷张力】
        const selectedList2 = ["deviceStatus","unwindingTension","rewindingTension"];
        const _selectedList2 = [];
        selectedList2.map((filedKey) => {
          const data = this.AloneData.chartVoList.find((item) => {
            return item.filedKey == filedKey;
          });
          if (data) _selectedList2.push(data);
        });
        this.chartList2 = _selectedList2;
        this.$store.commit("putInThePowderWeightUpdate", this.chartList1);
        this.$store.commit("totalWeightOfLiquidUpdate", this.chartList2);
      } else if (this.$store.state.data.machineId == "MC007") {
        const selectedList = ["equipmentEfficiency", "robotSpeed", "data1"];
        const _selectedList = [];
        selectedList.map((filedKey) => {
          const data = this.AloneData.chartVoList.find((item) => {
            return item.filedKey == filedKey;
          });
          if (data) _selectedList.push(data);
        });
        this.chartList1 = _selectedList;
        //进行数据选取
        const selectedList2 = [
          "deviceStatus",
          "data2",
          "data3",
        ];
        const _selectedList2 = [];
        selectedList2.map((filedKey) => {
          const data = this.AloneData.chartVoList.find((item) => {
            return item.filedKey == filedKey;
          });
          if (data) _selectedList2.push(data);
        });
        this.chartList2 = _selectedList2;
        this.$store.commit("putInThePowderWeightUpdate", this.chartList1);
        this.$store.commit("totalWeightOfLiquidUpdate", this.chartList2);
      } else if (this.$store.state.data.machineId == "MC008") {
        const selectedList = ["pre-solderingPower", "voltage", "pre-solderingTime"];
        const _selectedList = [];
        selectedList.map((filedKey) => {
          const data = this.AloneData.chartVoList.find((item) => {
            return item.filedKey == filedKey;
          });
          if (data) _selectedList.push(data);
        });
        this.chartList1 = _selectedList;
        //进行数据选取
        const selectedList2 = [
          "deviceStatus",
          "pre-solderingCooling",
          "ultrasonicFrequency",
        ];
        const _selectedList2 = [];
        selectedList2.map((filedKey) => {
          const data = this.AloneData.chartVoList.find((item) => {
            return item.filedKey == filedKey;
          });
          if (data) _selectedList2.push(data);
        });
        this.chartList2 = _selectedList2;
        this.$store.commit("putInThePowderWeightUpdate", this.chartList1);
        this.$store.commit("totalWeightOfLiquidUpdate", this.chartList2);
      } else if (this.$store.state.data.machineId == "MC009") {
        const selectedList = ["voltage", "finalWeldingPower", "finalWeldingTime"];
        const _selectedList = [];
        selectedList.map((filedKey) => {
          const data = this.AloneData.chartVoList.find((item) => {
            return item.filedKey == filedKey;
          });
          if (data) _selectedList.push(data);
        });
        this.chartList1 = _selectedList;
        //进行数据选取
        const selectedList2 = [
          "deviceStatus",
          "finalWeldingCooling",
          "ultrasonicFrequency",
        ];
        const _selectedList2 = [];
        selectedList2.map((filedKey) => {
          const data = this.AloneData.chartVoList.find((item) => {
            return item.filedKey == filedKey;
          });
          if (data) _selectedList2.push(data);
        });
        this.chartList2 = _selectedList2;
        this.$store.commit("putInThePowderWeightUpdate", this.chartList1);
        this.$store.commit("totalWeightOfLiquidUpdate", this.chartList2);
      } else if (this.$store.state.data.machineId == "MC010") {
         //进行左边的3个数据选取【A层温度 B层温度  A层真空值】
        const selectedList = ["A layerTemperature", "capacityEfficiency", "A layerVacuumValue"];
        const _selectedList = [];
        selectedList.map((filedKey) => {
          const data = this.AloneData.chartVoList.find((item) => {
            return item.filedKey == filedKey;
          });
          if (data) _selectedList.push(data);
        });
        this.chartList1 = _selectedList;
        //进行右边的3个数据选取【设备状态 真空泵气压 保压下限】
        const selectedList2 = ["deviceStatus","vacuumPumpAirPressure","lowerHoldingPressureLimit",];
        const _selectedList2 = [];
        selectedList2.map((filedKey) => {
          const data = this.AloneData.chartVoList.find((item) => {
            return item.filedKey == filedKey;
          });
          if (data) _selectedList2.push(data);
        });
        this.chartList2 = _selectedList2;

         //数据选取【B层温度】
        const selectedList3 = ["B layerTemperature"];
        const _selectedList3 = [];
        selectedList3.map((filedKey) => {
          const data = this.AloneData.chartVoList.find((item) => {
            return item.filedKey == filedKey;
          });
          if (data) _selectedList3.push(data);
        });
        this.BlayerTemperature = _selectedList3;
        this.$store.commit("putInThePowderWeightUpdate", this.BlayerTemperature);
        this.$store.commit("totalWeightOfLiquidUpdate", this.chartList2);
          //数据选取【B层真空值】
        const selectedList4 = ["B layerVacuumValue"];
        const _selectedList4 = [];
        selectedList4.map((filedKey) => {
          const data = this.AloneData.chartVoList.find((item) => {
            return item.filedKey == filedKey;
          });
          if (data) _selectedList4.push(data);
        });

        this.BlayerVacuumValue = _selectedList4;
        this.$store.commit("totalWeightOfLiquidUpdate", this.BlayerVacuumValue);
      } else if (this.$store.state.data.machineId == "MC011") {
        //进行左边的3个数据选取【设备效率 注液前称重  失液量】
        const selectedList = ["equipmentEfficiency", "weighBeforeFilling", "savalValue"];
        const _selectedList = [];
        selectedList.map((filedKey) => {
          const data = this.AloneData.chartVoList.find((item) => {
            return item.filedKey == filedKey;
          });
          if (data) _selectedList.push(data);
        });
        this.chartList1 = _selectedList;
        //进行右边的3个数据选取【设备状态 静止时间  真空值】
        const selectedList2 = ["deviceStatus","restTime","vacuumValue",];
        const _selectedList2 = [];
        selectedList2.map((filedKey) => {
          const data = this.AloneData.chartVoList.find((item) => {
            return item.filedKey == filedKey;
          });
          if (data) _selectedList2.push(data);
        });
        this.chartList2 = _selectedList2;

        //进行数据选取【注液后称重】
        const selectedList3 = ["weighAfterInjection"];
        const _selectedList3 = [];
        selectedList3.map((filedKey) => {
          const data = this.AloneData.chartVoList.find((item) => {
            return item.filedKey == filedKey;
          });
          if (data) _selectedList3.push(data);
        });
        this.weighAfterInjection = _selectedList3;
        this.data2 = _selectedList3;
        this.pointAbnormality = _selectedList2;
        this.pressedState = _selectedList;
        this.alarmInformation = _selectedList3;
        this.$store.commit("putInThePowderWeightUpdate", this.weighAfterInjection);
        this.$store.commit("totalWeightOfLiquidUpdate", this.chartList2);
      } else if (this.$store.state.data.machineId == "MC012") {
        //进行数据选取"pressedState"
        const selectedList = ["data1",];
        const _selectedList = [];
        selectedList.map((filedKey) => {
          const data = this.AloneData.chartVoList.find((item) => {
            return item.filedKey == filedKey;
          });
          if (data) _selectedList.push(data);
        });
        this.chartList1 = _selectedList;
        //进行数据选取"deviceStatus", "alarmInformation"
        const selectedList2 = ["data2"];
        const _selectedList2 = [];
        selectedList2.map((filedKey) => {
          const data = this.AloneData.chartVoList.find((item) => {
            return item.filedKey == filedKey;
          });
          if (data) _selectedList2.push(data);
        });
        this.chartList2 = _selectedList2;

        //进行数据选取【设备运行状态】
        const selectedList3 = ["deviceOperatingStatus"];
        const _selectedList3 = [];
        selectedList3.map((filedKey) => {
          const data = this.AloneData.chartVoList.find((item) => {
            return item.filedKey == filedKey;
          });
          if (data) _selectedList3.push(data);
        });
        this.data2 = _selectedList3;

        // 进行数据选取【点位异常】
        const selectedList4 = ["pointAbnormality"];
        const _selectedList4 = [];
        selectedList4.map((filedKey) => {
          const data = this.AloneData.chartVoList.find((item) => {
            return item.filedKey == filedKey;
          });
          if (data) _selectedList4.push(data);
        });
        this.pointAbnormality = _selectedList4;

         // 进行数据选取【压合状态】
        const selectedList5 = ["pressedState"];
        const _selectedList5 = [];
        selectedList5.map((filedKey) => {
          const data = this.AloneData.chartVoList.find((item) => {
            return item.filedKey == filedKey;
          });
          if (data) _selectedList5.push(data);
        });
        this.pressedState = _selectedList5;
         // 进行数据选取【报警信息】
        const selectedList6 = ["alarmInformation"];
        const _selectedList6 = [];
        selectedList6.map((filedKey) => {
          const data = this.AloneData.chartVoList.find((item) => {
            return item.filedKey == filedKey;
          });
          if (data) _selectedList6.push(data);
        });
        this.alarmInformation = _selectedList6;

        this.$store.commit("putInThePowderWeightUpdate", this.pointAbnormality);
        this.$store.commit("totalWeightOfLiquidUpdate", this.chartList2);
      } else if (this.$store.state.data.machineId == "MC013") {
         //进行左边的3个数据选取【上封刀温度 当前效率  真空值】
        const selectedList = ["upperSealingKnifeTemperature", "currentEfficiency", "vacuumValue"];
        const _selectedList = [];
        selectedList.map((filedKey) => {
          const data = this.AloneData.chartVoList.find((item) => {
            return item.filedKey == filedKey;
          });
          if (data) _selectedList.push(data);
        });
        this.chartList1 = _selectedList;
         //进行右边的3个数据选取【设备状态 封口时间  封口次数】
        const selectedList2 = ["deviceStatus","sealingTime","numberOfSeals",];
        const _selectedList2 = [];
        selectedList2.map((filedKey) => {
          const data = this.AloneData.chartVoList.find((item) => {
            return item.filedKey == filedKey;
          });
          if (data) _selectedList2.push(data);
        });
        this.chartList2 = _selectedList2;

        //进行数据选取【下封刀温度】
        const selectedList3 = ["lowerSealingKnifeTemperature"];
        const _selectedList3 = [];
        selectedList3.map((filedKey) => {
          const data = this.AloneData.chartVoList.find((item) => {
            return item.filedKey == filedKey;
          });
          if (data) _selectedList3.push(data);
        });
        this.lowerSealingKnifeTemperature = _selectedList3;
        this.data2 = _selectedList3;
        this.pointAbnormality = _selectedList2;
        this.pressedState = _selectedList;
        this.alarmInformation = _selectedList3;
        this.$store.commit("putInThePowderWeightUpdate", this.lowerSealingKnifeTemperature);
        this.$store.commit("totalWeightOfLiquidUpdate", this.chartList2);
      } else if (this.$store.state.data.machineId == "MC014") {
        //进行左边的3个数据选取【设备效率 产能效率  顶封封口时间】
        const selectedList = ["SVXL","capacityEfficiency","DFFKSJ"];
        const _selectedList = [];
        selectedList.map((filedKey) => {
          const data = this.AloneData.chartVoList.find((item) => {
            return item.filedKey == filedKey;
          });
          if (data) _selectedList.push(data);
        });
        this.chartList1 = _selectedList;
        //进行数据选取
        //行右边的3个数据选取【设备状态 侧封上封刀温度  顶封上封刀温度】
        const selectedList2 = ["deviceStatus","CFSFDWD","DFSFDWD"];
        const _selectedList2 = [];
        selectedList2.map((filedKey) => {
          const data = this.AloneData.chartVoList.find((item) => {
            return item.filedKey == filedKey;
          });
          if (data) _selectedList2.push(data);
        });
        this.chartList2 = _selectedList2;

        //数据选取【侧封下封刀温度】
        const selectedList3 = ["CFXFDWD"];
        const _selectedList3 = [];
        selectedList3.map((filedKey) => {
          const data = this.AloneData.chartVoList.find((item) => {
            return item.filedKey == filedKey;
          });
          if (data) _selectedList3.push(data);
        });
        this.autorotationSpeed = _selectedList3;
        this.$store.commit("putInThePowderWeightUpdate", this.autorotationSpeed);
       //数据选取【顶封下封刀温度】
        const selectedList4 = ["DFXFDWD"];
        const _selectedList4 = [];
        selectedList4.map((filedKey) => {
          const data = this.AloneData.chartVoList.find((item) => {
            return item.filedKey == filedKey;
          });
          if (data) _selectedList4.push(data);
        });
        this.BlayerVacuumValue = _selectedList4;
        this.$store.commit("totalWeightOfLiquidUpdate", this.BlayerVacuumValue);
      } else if (this.$store.state.data.machineId == "MC015") {
        const selectedList = ["coreHeight", "windingSpeed", "dustRemovalWindSpeed"];
        const _selectedList = [];
        selectedList.map((filedKey) => {
          const data = this.AloneData.chartVoList.find((item) => {
            return item.filedKey == filedKey;
          });
          if (data) _selectedList.push(data);
        });
        this.chartList1 = _selectedList;
        //进行数据选取
        const selectedList2 = [
          "resistanceSetting",
          "ZJJPZL",
          "FJJPZL",
        ];
        const _selectedList2 = [];
        selectedList2.map((filedKey) => {
          const data = this.AloneData.chartVoList.find((item) => {
            return item.filedKey == filedKey;
          });
          if (data) _selectedList2.push(data);
        });
        this.chartList2 = _selectedList2;
        this.$store.commit("putInThePowderWeightUpdate", this.chartList1);
        this.$store.commit("totalWeightOfLiquidUpdate", this.chartList2);
      }else if(this.$store.state.data.machineId == "MC017"){
        const selectedList = ["temperature", "vacuum", "deviceStatus"];
        const _selectedList = [];
        selectedList.map((filedKey) => {
          const data = this.AloneData.chartVoList.find((item) => {
            return item.filedKey == filedKey;
          });
          if (data) _selectedList.push(data);
        });
        this.chartList1 = _selectedList;

         //进行数据选取
         const selectedList2 = [
          "data1",
          "data2",
          "data3",
        ];
        const _selectedList2 = [];
        selectedList2.map((filedKey) => {
          const data = this.AloneData.chartVoList.find((item) => {
            return item.filedKey == filedKey;
          });
          if (data) _selectedList2.push(data);
        });
        this.chartList2 = _selectedList2;
        this.$store.commit("putInThePowderWeightUpdate", this.chartList1);
        this.$store.commit("totalWeightOfLiquidUpdate", this.chartList2);
      }
       else {
        console.log("其它---->");
      }
    },
    machine(arrId, MCId) {
      return request({
        url: "/machine/" + arrId + "/chart?machineId=" + MCId,
        method: "get",
        data: {},
      });
    },
  },
  watch: {
    isEdit(n) {
      this.isContEdit = n;
    },
    chartList1:{
      handler(newValue,oldValue){
        this.chartList1 = newValue;
      },
      deep:true
    },
    chartList2:{
      handler(newValue,oldValue){
        this.chartList2 = newValue;
      },
      deep:true
    }
  },
  destroyed() {
    //清除定时器
    if (this.getDataInterval) clearInterval(this.getDataInterval);
  },
};
</script>
<style lang="less" scoped>
.stand-alone {
  display: flex;
  position: relative;
  .charts {
    width: 420px;
    height: 100%;
  }
  
  #standAlone-model {
    width: calc(100% - 844px);
    height: 100%;
  }

  .model {
    width: calc(100% - 844px);
    height: 100%;
  }

  .chart-cont2 {
    position: fixed;
    // float:right;
    left: 92.25rem;
    top: 52rem;
    width: 22%;
    height: calc(33% - 36px);
    background: url("../../module/images/chart-bg.png") no-repeat 0 0;
    background-size: 100% 100%;
    padding: 4px 12px 14px;
    overflow: auto;
  
  }
}
</style>